import { FC, ReactNode } from "react";

import { AppUser } from "src/authentication/appUser.ts";
import { Permission } from "src/authentication/PermissionsProvider";
import { usePermissions } from "src/authentication/usePermissions.ts";
import { AuthorizedError } from "src/errors/authorized.error.ts";

type AuthorizedRouteProps = {
  children: ReactNode;
  requiredPermissions: Permission[];
  pageTitle: string;
};

export const AuthorizedRoute: FC<AuthorizedRouteProps> = ({
  children,
  requiredPermissions,
  pageTitle,
}) => {
  const { hasPermissions } = usePermissions();
  const isAuthorized = hasPermissions(requiredPermissions);

  if (isAuthorized || !AppUser.isAuthenticationEnabled) {
    return <>{children}</>;
  }

  throw new AuthorizedError("NotAuthorized", pageTitle);
};
